import {
  useInfiniteQuery,
  keepPreviousData,
} from "@tanstack/react-query";
import {
  getAdminOpenIssuesQueryKey,
  fetchAdminOpenIssuesPage,
  ADMIN_OPEN_ISSUES_PAGE_SIZE,
} from "@/lib/adminOpenIssues";

export function useAdminOpenIssues(orgId: string) {
  return useInfiniteQuery({
    queryKey: getAdminOpenIssuesQueryKey(orgId),
    queryFn: ({ pageParam }) => fetchAdminOpenIssuesPage(orgId, pageParam),
    initialPageParam: 0,
    getNextPageParam: (lastPage, _allPages, lastPageParam) => {
      if (lastPage.length < ADMIN_OPEN_ISSUES_PAGE_SIZE) return undefined;
      return lastPageParam + 1;
    },
    staleTime: 30_000,
    placeholderData: keepPreviousData,
  });
}
